<template>
  <div>
    <DxPopup
      v-model:visible="popupLinkVisible"
      :drag-enabled="true"
      :show-close-button="true"
      :close-on-outside-click="false"
      :show-title="true"
      :resizeEnabled="true"
      title="User Role Management"
    >
      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="before"
        :options="saveLinkButtonOptions"
      />

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="closeLinkButtonOptions"
      />

      <DxDataGrid
        :columns="columns"
        :data-source="dataStore1"
        :show-borders="true"
        :allow-column-resizing="true"
        :showRowLines="true"
        :height="400"
        :hover-state-enabled="true"
        :remote-operations="true"
        selection.mode="single"
        :ref="dataGridRefKey"
        @selection-changed="onSelectionChanged"
      >
        <DxFilterRow :visible="true" />

        <DxPaging :page-size="5" />

        <DxPager
          :visible="true"
          display-mode="full"
          :show-page-size-selector="false"
          :show-info="true"
          :show-navigation-buttons="true"
        />
      </DxDataGrid>
    </DxPopup>
  </div>
</template>

<script>
import {
  DxColumn,
  DxFormItem,
  DxEditing,
  DxLookup,
  DxGrouping,
  DxColumnChooser,
  DxLoadPanel,
  DxToolbar,
  DxDataGrid,
  DxSelection,
  DxFilterRow,
  DxScrolling,
  DxPager,
  DxPaging,
} from "devextreme-vue/data-grid";

import { DxPopup, DxPosition, DxToolbarItem } from "devextreme-vue/popup";
import {
  getGridData,
  getHeaders,
  getQuickCreateDef,
} from "@include/utils/GridUtils.js";
import CustomStore from "devextreme/data/custom_store";
import BsEditForm from "@include/forms/BsEditForm.vue";
import { confirm, alert } from "devextreme/ui/dialog";
const dataGridRefKey = "my-dat-grid";

export default {
  props: {
    routeDef: String,
    parentRoute: String,
    slug: String,
  },
  components: {
    DxColumn,
    DxFormItem,
    DxEditing,
    DxLookup,
    DxGrouping,
    DxColumnChooser,
    DxLoadPanel,
    DxToolbar,
    DxDataGrid,
    DxSelection,
    DxFilterRow,
    DxPopup,
    DxPosition,
    DxToolbarItem,
    BsEditForm,
    alert,
    confirm,

    DxPager,
    DxPaging,
    DxScrolling,
  },
  data: function () {
    //getGridData("/roles/list", { id: "hh" })
    return {
      headersDef: [],
      columns: [],
      selectedIds: "",
      popupLinkVisible: false,
      user_id: "",
      dataGridRefKey,
      dataStore1: "",
      record_id: "",
      request_type: "",
      tenant_id: "",

      pageSizes: [10, 25, 50, 100],
      saveLinkButtonOptions: {
        icon: "save",
        text: "Save",
        onClick: () => {
          this.onSave();
        },
      },
      closeLinkButtonOptions: {
        text: "Close",
        onClick: () => {
          this.popupLinkVisible = false;
        },
      },
    };
  },
  mounted() {
    /* load header for list */

    if (this.routeDef == "tenant-admin-panels.subscriptions") {
      this.columns = [{ dataField: "name", caption: "Name", name: "name" }];

      this.dataStore1 = getGridData(
        "/" + this.slug + "/tenant-admin-panels/users/list",
        { id: "hh" }
      );
      //console.log("LIC USER GRID DATA ",this.receivedValue);
    } else {
      this.columns = [{ dataField: "name", caption: "Name", name: "name" }];

      this.dataStore1 = getGridData("/" + this.slug + "/roles/list", {
        id: "hh",
      });
    }
  },
  methods: {
    showRolePopUp() {
      this.popupLinkVisible = true;
    },
    onSelectionChanged(e) {
      console.log("Selected data", e.selectedRowsData);
      if (e.selectedRowsData.length > 0) {
        if (this.routeDef == "tenant-admin-panels.subscriptions") {
          const containsValue = this.relatedUsers.some(
            (item) => item.id === e.selectedRowsData[0].id
          );

          if (containsValue) {
            alert("Please Select Another Record", "Already Assigned!");
            this.dataGrid.clearSelection();
          } else {
            this.selectedIds = e.selectedRowKeys[0];
          }
        } else {
          this.selectedIds = e.selectedRowKeys[0];
        }
      }
    },
    setData(e) {
      if (this.routeDef == "tenant-admin-panels.subscriptions") {
        this.record_id = e.row.data.id;
        this.relatedUsers = e.row.data.relatedUsers;
      } else {
        this.record_id = e.row.data.id;
        this.user_id = e.row.data.user_id;
        this.request_type = e.row.data.type;
        console.log("user_id", this.user_id);
      }
    },
    onSave() {
      if (this.routeDef == "tenant-admin-panels.subscriptions") {
        this.$inertia.post(
          "/" + this.slug + "/tenant-admin-panels/subscriptions/assignLicence",
          {
            record_id: this.record_id,
            user_id: this.selectedIds,
          }
        );
      } else {
        console.log("Type_id_request", this.request_type);
        var recordId = this.record_id;
        var roleId = this.selectedIds;
        var userId = this.user_id;
        var reqtype = this.request_type;

        var data = {
          record_id: recordId,
          role_id: roleId,
          user_id: userId,
          request_type: reqtype,
        };

        // inertia.post("/user-tenant-access-requests/accessApproved", data);
        this.$inertia.post(
          route("user-tenant-access-requests.accessApproved", this.slug),
          data
        );
      }

      this.popupLinkVisible = false;
    },
  },
  computed: {
    dataGrid: function () {
      return this.$refs[dataGridRefKey].instance;
    },
  },
};
</script>

<style>
</style>